var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewron2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconChewron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20883 8.53155C8.09349 8.6508 7.9065 8.6508 7.79117 8.53155L3.97868 4.58944C3.86334 4.47019 3.67635 4.47019 3.56102 4.58944L2.5865 5.59709C2.47117 5.71635 2.47117 5.90969 2.5865 6.02895L7.79117 11.4106C7.90651 11.5298 8.09349 11.5298 8.20883 11.4106L13.4135 6.02895C13.5288 5.90969 13.5288 5.71635 13.4135 5.59709L12.439 4.58944C12.3236 4.47019 12.1367 4.47019 12.0213 4.58944L8.20883 8.53155Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewron2);
export default __webpack_public_path__ + "static/media/iconChewron2.994e6ffbf258fe43023a59b294959eae.svg";
export { ForwardRef as ReactComponent };